import { render } from "./Setting.vue?vue&type=template&id=688d0865&scoped=true&ts=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=688d0865&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688d0865"]])

export default __exports__